import PropTypes from 'prop-types';
import { useState } from 'react';

import { BaseURL } from '../../../../base/env';
import DetailModal from '../../ProductItem/DetailModal/DetailModal';
import useProductItem from '../../ProductItem/useProductItem';
import DoubleBanners from './DoubleBanners/DoubleBanners';
import SingleBanner from './SingleBanner';

const Banner = ({ data }) => {
  // const data = {
  //   "id": 701328,
  //   "type": "banner",
  //   "image": "/media/slider_images/SM1040.jpg",
  //   "image_2": null,
  //   "color": null,
  //   "url": "category/1/33/33#product-701943",
  //   "url_2": "",
  //   "use_details": true,
  //   "use_details_2": false,
  //   "now": null,
  //   "started_at1": "2023-11-15T15:10:42.332537Z",
  //   "started_at2": "2023-11-15T15:10:42.332537Z",
  //   "ended_at1": "2023-11-17T15:10:42.332537Z",
  //   "ended_at2": "2023-11-17T15:10:42.332537Z",
  //   "product": {
  //     "id": 712129,
  //     "product_id": 701943,
  //     "tag": "product-701943",
  //     "name": "2 کارتن SM مدل (40-10) 4 لیتر موتوسل+1 کارتن SJ مدل پاور پلاس پلاستیکی (40-10) 4 لیتر سپاهان",
  //     "label_style": "none",
  //     "label": "",
  //     "label_2": "",
  //     "use_details": true,
  //     "product_link": "",
  //     "unit": "بسته",
  //     "items_unit": "بسته",
  //     "items_quantity": 1,
  //     "price": 56251282,
  //     "payable_amount": 52063271,
  //     "discount_amount": 4188011,
  //     "usable_credit_amount": 52063271,
  //     "image": "/media/images/SM_1040_SJ_1040_uXiUshy.png",
  //     "is_active": true,
  //     "cash_payment": false,
  //     "details": [
  //       {
  //         "name": "2 کارتن SM مدل (40-10) 4 لیتر موتوسل+1 کارتن SJ مدل پاور پلاس پلاستیکی (40-10) 4 لیتر سپاهان",
  //         "value": " ",
  //         "table": "info"
  //       },
  //       {
  //         "name": "روغن موتور SM مدل (10W-40) حجم 4 لیتر موتوسل ",
  //         "price": 5312102,
  //         "discount": 265605,
  //         "table": "fee"
  //       },
  //       {
  //         "name": "روغن موتور SJ مدل پاور پلاس پلاستیکی (10W-40) حجم 4 لیتر سپاهان ",
  //         "price": 2292411,
  //         "discount": 343862,
  //         "table": "fee"
  //       },
  //       {
  //         "label": "1"
  //       },
  //       {
  //         "ribbon": "147,100"
  //       }
  //     ],
  //     "fixed_discount_amount": 4188011,
  //     "discount_percentage": 7,
  //     "visible_discount_type": "fixed",
  //     "purchasable_count": 5,
  //     "count_step": 1,
  //     "item_price": 56251282,
  //     "item_fixed_discount_amount": 4188011,
  //     "item_payable_amount": 52063271,
  //     "quantity": 0,
  //     "cities": [
  //       4034,
  //       4044,
  //       4058,
  //       4131,
  //       4140,
  //       4214,
  //       4218,
  //       4257,
  //       4258,
  //       4288,
  //       4312,
  //       4318,
  //       4323,
  //       4333,
  //       4345,
  //       4350,
  //       4351,
  //       4352,
  //       4353,
  //       4359,
  //       4363,
  //       4368,
  //       4372,
  //       4376,
  //       4391,
  //       4498,
  //       5057
  //     ],
  //     "site": 4
  //   },
  //   "product_2": null,
  //   "external_url": false,
  //   "external_url_2": false,
  //   "design1": {
  //     "code": 1,
  //     "position": "bl",
  //     "color": "#EE2A7B"
  //   },
  //   "design2": {
  //     "code": 1,
  //     "position": "bl",
  //     "color": "#EE2A7B"
  //   }
  // }
  const [productModalData, setProductModalData] = useState();
  const [
    shareModal, //eslint-disable-line
    setShareModal,
    isModalVisible,
    HideModal,
    showModal_visible,
    add_to_cart,
    store,
    history
  ] = useProductItem();
  if (data.image_2) {
    return (
      <>
        <DoubleBanners
          data={data}
          setProductModalData={setProductModalData}
          showModal_visible={showModal_visible}
        />
        <DetailModal
          add_to_cart={add_to_cart}
          data={productModalData || {}}
          HideModal={HideModal}
          isModalVisible={isModalVisible}
          setShareModal={setShareModal}
          showShare={false}
          store={store}
        />
      </>
    );
  }
  return (
    <>
      <SingleBanner
        data={data}
        external_url={data.external_url}
        image_url={BaseURL + data.image}
        onClick={() => {
          if (data.product) {
            setProductModalData(data.product);
            showModal_visible(true);
          } else if (data.url) {
            history.push(data.url);
          }
        }}
        url={data.url}
      />
      <DetailModal
        add_to_cart={add_to_cart}
        data={data.product ? data.product : {}}
        HideModal={HideModal}
        isModalVisible={isModalVisible}
        setShareModal={setShareModal}
        showShare={false}
        store={store}
      />
    </>
  );
};

Banner.propTypes = {
  data: PropTypes.object
};

export default Banner;
